import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { LoaderService } from './loader.service';
import { LoaderState } from './loader.classes';
// import { CancelRequestService } from 'src/app/services/core/cancel-request.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = false;
  private subscription: Subscription;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(private loaderService: LoaderService,
    //private cancelRequestService: CancelRequestService
  ) { }
  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.show = state.show;
      });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  // cancelRequest() {
  //   this.cancelRequestService.cancelRequest.emit();
  // }
}
